interface DonutChartProps {
    used: number;
    limit: number;
    percentage: number;
    baseColor: string;
}

function formatNumber(n: number): string {
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
    return n.toString();
}

export default function DonutChart({ used, limit, percentage, baseColor }: DonutChartProps) {
    const size = 120;
    const stroke = 10;
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (Math.min(percentage, 100) / 100) * circumference;
    const isOver = percentage > 100;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow flex flex-col items-center justify-center h-full">
            <h3 className="text-sm font-semibold text-gray-900 mb-4 self-start">Consumo del mes</h3>

            <svg width={size} height={size} className="mb-3">
                <circle
                    cx={size / 2} cy={size / 2} r={radius}
                    fill="none" stroke="#F3F4F6" strokeWidth={stroke}
                />
                <circle
                    cx={size / 2} cy={size / 2} r={radius}
                    fill="none"
                    stroke={isOver ? '#EF4444' : baseColor}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    className="transition-all duration-700"
                />
                <text x={size / 2} y={size / 2 + 1} textAnchor="middle" fontSize="1.1rem" fontWeight="bold" fill="#111827">
                    {percentage}%
                </text>
            </svg>

            <p className="text-xs text-gray-500 font-medium tabular-nums">
                {formatNumber(used)} / {formatNumber(limit)}
            </p>
            <div className="flex items-center gap-3 mt-2 text-[10px] text-gray-400">
                <span className="flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: isOver ? '#EF4444' : baseColor }} />
                    Enviados
                </span>
                <span className="flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-200" />
                    Limite
                </span>
            </div>
        </div>
    );
}
